package Structs

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import myName

@myName("ClientProductData")
@Serializable
data class ClientProductData(
    val client_id: Int,
    val product_id: Int,
    val barcode: String? = null,
    /** -1=unlimited, 0=deny, >0=max return % this product, null=inherit (def client_id=0, else -1). */
    val returns: Float? = null,
) {
    fun toJson(): JsonObject {
        val map: MutableMap<String, JsonPrimitive> = mutableMapOf()

        map["client_id"] = JsonPrimitive(client_id.toString())
        map["product_id"] = JsonPrimitive(product_id.toString())
        if (barcode != null)
            map["barcode"] = JsonPrimitive(barcode.toString())
        if (returns != null)
            map["returns"] = JsonPrimitive(returns.toString())
        return JsonObject(map)
    }
}
